import { z } from 'zod';

export const CS_REVIEW_ARTICLE_BODY_MAX_LENGTH = 40_000;
export const CS_REVIEW_RULE_MAX_LENGTH = 2000;
export const CS_REVIEW_RATIONALE_MAX_LENGTH = 2000;

export const KbEditProposalSchema = z.object({
  articleId: z.uuid().nullable(),
  articleVersion: z.number().int().positive().nullable(),
  articlePath: z.string().min(1).max(300),
  title: z.string().min(1).max(200),
  before: z.string().max(CS_REVIEW_ARTICLE_BODY_MAX_LENGTH),
  after: z.string().min(1).max(CS_REVIEW_ARTICLE_BODY_MAX_LENGTH),
  redraft: z.string().nullable(),
  rationale: z.string().min(1).max(CS_REVIEW_RATIONALE_MAX_LENGTH),
});
export type KbEditProposal = z.infer<typeof KbEditProposalSchema>;

export const PromptRuleProposalSchema = z.object({
  agentSlug: z.string().min(1).max(63),
  rule: z.string().min(1).max(CS_REVIEW_RULE_MAX_LENGTH),
  redraft: z.string().nullable(),
  rationale: z.string().min(1).max(CS_REVIEW_RATIONALE_MAX_LENGTH),
});
export type PromptRuleProposal = z.infer<typeof PromptRuleProposalSchema>;

const ScoreSchema = z.number().int().min(1).max(5);

export const DraftReviewScoresSchema = z.object({
  accuracy: ScoreSchema,
  style: ScoreSchema,
  judgement: ScoreSchema,
  match: ScoreSchema,
  note: z.string().max(CS_REVIEW_RATIONALE_MAX_LENGTH).nullable(),
});
export type DraftReviewScores = z.infer<typeof DraftReviewScoresSchema>;

export const RECORD_PROPOSAL_KINDS = ['kb-edit', 'kb-new', 'prompt-rule', 'scores'] as const;

export const RecordProposalArgsSchema = z.object({
  kind: z.enum(RECORD_PROPOSAL_KINDS),
  articlePath: z.string().min(1).max(300).nullable(),
  title: z.string().min(1).max(200).nullable(),
  after: z.string().min(1).max(CS_REVIEW_ARTICLE_BODY_MAX_LENGTH).nullable(),
  rule: z.string().min(1).max(CS_REVIEW_RULE_MAX_LENGTH).nullable(),
  rationale: z.string().min(1).max(CS_REVIEW_RATIONALE_MAX_LENGTH).nullable(),
  accuracy: ScoreSchema.nullable(),
  style: ScoreSchema.nullable(),
  judgement: ScoreSchema.nullable(),
  match: ScoreSchema.nullable(),
  note: z.string().max(CS_REVIEW_RATIONALE_MAX_LENGTH).nullable(),
});
export type RecordProposalArgs = z.infer<typeof RecordProposalArgsSchema>;
